import Footer from "../components/footer";
import NavBar from "../components/navBar";
import LinkComponent from "../components/link";

function SubscriptionSection() {
    return (
        <div className="container d-flex flex-column" style={{height: "90vh"}}>
            <p className="mx-auto my-5 text-light" style={{fontSize: "clamp(3em,3vw,8em)"}}>Coming Soon!</p>
            <div className="mx-auto">
                <LinkComponent
                    component={<button className="btn btn-dark text-light rounded text-center px-0" 
                    style={{width: "120px"}}>SweetWoodFlora</button>} link={"/"}
                />
            </div>
            
        </div>
    );
}

function Payment() {
    return (
        <div>
            <NavBar/>
            <SubscriptionSection/>
            <Footer/>
        </div>
    );
}

export default Payment;